import { useState } from 'react';
import { Outlet } from "react-router-dom";
import { Box } from '@mui/material';
import TopBar from './topbar'
import SideBar from './sidebar'

const Layout = () => {
    console.log('layout')
    const [sideBarOpen, setSideBarOpen] = useState(false)
    return (
        <>
            <TopBar sideBarOpen={sideBarOpen} setSideBarOpen={setSideBarOpen}/>
            <SideBar open={sideBarOpen} setOpen={setSideBarOpen}/>
            <Outlet />
        </>
    );
};

export default Layout